import React, { useState } from 'react'

import { getNewCounts } from './utils'
import { ISelectCountHashmap } from '../../types/plan'
import { DrugItem } from './components/DrugItem/DrugItem'
import { EntitlementButtons } from './components/EntitlementButtons'
import { IDrug } from '../../types/drug'

import './index.scss'

interface IProps {
  data: IDrug[]
  selectedDrugs: ISelectCountHashmap
  setSelectedDrugs: (selectCounts: ISelectCountHashmap) => void
}

const EntitlementsInput: React.FC<IProps> = ({ data, selectedDrugs, setSelectedDrugs }) => {
  const [searchText, setSearchText] = useState('')
  const [limitInput, setLimitInput] = useState(-1)
  const [selectedAll, setSelectedAll] = useState<boolean>(false)

  const handleSearchChange = (e: React.FormEvent<any>) => {
    if (e.currentTarget.value) {
      setSearchText(e.currentTarget.value.toLowerCase())
      return
    }
    setSearchText('')
  }

  const handleListSelect = (e: React.FormEvent<any>) => {
    if (e.currentTarget.value) {
      setSelectedDrugs({
        ...selectedDrugs,
        [e.currentTarget.value]: {
          count: selectedDrugs[e.currentTarget.value]?.count || 0,
          selected: !selectedDrugs[e.currentTarget.value]?.selected
        }
      })
    }
  }

  const handleSelectAll = (e: React.FormEvent<any>) => {
    const allSelected: ISelectCountHashmap = {}
    for (const key of Object.keys(selectedDrugs)) {
      allSelected[key] = { ...selectedDrugs[key], selected: e.currentTarget.checked ? e.currentTarget.checked : false }
    }
    setSelectedDrugs(allSelected)
    setSelectedAll(e.currentTarget.checked ? e.currentTarget.checked : false)
  }

  const removeEntitlement = (evt: React.FormEvent<HTMLButtonElement>, entitlement: number): void => {
    evt.preventDefault()
    setSelectedDrugs({
      ...selectedDrugs,
      [entitlement]: {
        ...selectedDrugs[entitlement],
        count: 0
      }
    })
  }

  const listItems = (items: IDrug[]): JSX.Element => (
    <div className='drugsList'>
      {
        items.map(item => {
          const count = selectedDrugs[item.id] ? selectedDrugs[item.id].count : 0

          return (
            <DrugItem
              module={item.module}
              name={item.name}
              key={`drug-item-${item.id}`}
              id={item.id}
              count={count}
              handleListSelect={handleListSelect}
              handleRemove={removeEntitlement}
              checked={selectedDrugs[item.id] ? selectedDrugs[item.id].selected : false}
            />
          )
        })
      }
    </div>
  )

  let filteredData = data

  if (data && searchText) {
    filteredData = data.filter(x =>  x.module.toLowerCase().includes(searchText))
  }

  const updateCounts = () => {
    const input = limitInput < -1 ? -1 : limitInput
    const newCounts = getNewCounts(selectedDrugs, input)
    setSelectedDrugs({
      ...selectedDrugs, ...newCounts
    })
    setSelectedAll(false)
  }

  const content: JSX.Element = (
    <div className='entitlements-container'>
      <div className='form-field-label'>Drug Entitlements</div>
      <div id='entitlement-wrapper'>
        <div className='drug-entitlement-search'>
          <input
            id='drug-search'
            placeholder='Search'
            aria-label='Search'
            onChange={handleSearchChange}
          />
        </div>

        <div id='all-drugs-wrapper'>
          <div
            id='all-drugs-inner'
            className='d-flex align-items-center'
          >
            <input
              type='checkbox'
              id='allDrugs'
              // @ts-ignore
              onChange={handleSelectAll}
              disabled={!!searchText.length}
              checked={selectedAll}
            />
            <label
              id='all-drugs-label'
              htmlFor='allDrugs'
              className='mb-0'
            >
              All Drugs
            </label>
          </div>
        </div>

        {filteredData && listItems(filteredData)}

        <EntitlementButtons
          updateCounts={updateCounts}
          setLimitInput={setLimitInput}
        />
      </div>
    </div>
  )

  return content
}

export {
  EntitlementsInput
}
